import React, { useState, useEffect } from 'react';
import "../../common.css";
import "../../investorAcademy.css";
import { Link, useLocation, useHistory, BrowserRouter as Router } from 'react-router-dom';
import ChildInvestorAcademyCommon from '../../../../../components/common/InvestorAcademyCommon/ChildInvestorAcademyCommon';
import SelectingWarrentImg from '../../../../../components/common/SelectingWarrentImg';

const GearingEffects = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const [openLive, setOpenLive] = useState(false);
    const [imageUrl, setImageUrl] = useState("");
    const location = useLocation();
    const history = useHistory();



    return (
        <div id="investor_academy">
            <div className="imgbg"/>
            <div className="mainbg"></div>

            <div id="main">
                <div id="maintable" className='gearing_effect Common_warrent' style={{ display: 'table', width: '100%', tableLayout: 'fixed' }}>
                    <div style={{ display: 'table-row' }}>
                        <div id="leftbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }} />
                        <div id="maincontainer" style={{ display: 'table-cell', width: '100%' }}>
                            <div id="mainnav">
                                <table style={{ width: '100%', tableLayout: 'fixed', borderBottom: '1px solid #353223' }}>
                                    <tbody><tr>
                                        <td width="20%" style={{ textAlign: 'left', visibility: 'hidden' }}>
                                            <table className="hasprev hidden-xs" style={{ width: '100%', height: '100%', tableLayout: 'fixed' }}>
                                                <tbody><tr>
                                                    <td width="33px"><Link to="/edu/why-trade-warrant"><div className="prev left" /></Link></td>
                                                    <td>
                                                        <div className="prevlbl left">
                                                            <div className="prevtitle " style={{ textAlign: 'left' }}>Previous Topic</div>
                                                            <div className="prevname " style={{ textAlign: 'left' }}>
                                                                <Link to="/edu/why-trade-warrant">
                                                                    Why Trade Warrants?
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                </tbody></table>
                                        </td>
                                        <td width="60%" style={{ textAlign: 'center' }}>
                                            <div id="pagetitlediv" style={{ width: '365px', height: '100%', borderBottom: '1px solid #FFD843', margin: 'auto' }}>
                                                <div id="ptitle" style={{ fontFamily: 'HelveticaNeueThinCond', fontSize: '25px', color: 'white', letterSpacing: '1px' }}>

                                                    Why Trade Warrants?
                                                </div>
                                                <div id="pname" style={{ fontFamily: 'HelveticaNeueThinCond', fontSize: '30px', color: '#FFD843', letterSpacing: '1px', paddingTop: '5px', paddingBottom: '5px' }}>Gearing effect</div>
                                            </div>
                                        </td>
                                        <td width="20%" style={{ textAlign: 'right', visibility: 'hidden' }}>
                                            <table className="hasnext  hidden-xs" style={{ width: '100%', height: '100%', tableLayout: 'fixed' }}>
                                                <tbody><tr>
                                                    <td>
                                                        <div className="nextlbl right">
                                                            <div className="nexttitle " style={{ textAlign: 'right' }} />
                                                            <div className="nextname " style={{ textAlign: 'right' }}>
                                                                <Link to="/edu/why-trade-warrant/limited-loss">
                                                                    Limited loss
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td width="33px"><Link to="/edu/why-trade-warrant/limited-loss"><div className="next right" /></Link></td>
                                                </tr>
                                                </tbody></table>
                                        </td>
                                    </tr>
                                    </tbody></table>
                            </div>
                            <div id="maincontent" style={{ marginLeft: '10px', marginRight: '10px', paddingTop: '40px', marginBottom: '60px' }}>
                                <div id="mainscroll" style={{ height: '100%', overflowX: 'hidden', overflowY: 'auto', paddingLeft: '90px', paddingRight: '90px' }}>
                                    <div id="mainscrollcontent">
                                        <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
                                        {/*<link rel="stylesheet" href="css/common.css"/>*/}
                                        <title>Gearing effect</title>
                                        <style dangerouslySetInnerHTML={{ __html: "\n            .imgholder h4{\n                margin:0;\n            }\n            .imgholder img{\n                max-width: 724px;\n/*                margin-left:-75px;*/\n            }\n        " }} />
                                        <div className="contentbox">
                                            <p>A warrant enables you to gain exposure to a security for just a fraction of its price, meaning you can get a similar effective exposure for a much smaller capital outlay. Therefore, warrants tend to move in greater percentages than the underlying shares, allowing you the potential for higher percentage returns than if you had bought the shares directly. This is known as the gearing effect and the main reason warrants are so popular with investors.</p>
                                            <div className="imgholder">
                                                <h4 className='text-white'>Share vs Warrant Performance</h4>
                                                <img src="/img/education/chart_gearingeffect.png" />
                                            </div>
                                            {/* className="map_pop" */}
                                            <div className="map_pop">
                                                <div
                                                    className="how_put"
                                                    data-bs-toggle="collapse"
                                                    href="#popup-image"
                                                    role="text"
                                                    aria-expanded="false"
                                                    aria-controls="popup-image"
                                                    onClick={() => { return setOpenLive(true), setImageUrl("/img/education/chart_gearingeffectMob.png") }}
                                                    >View Chart
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="rightbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }}>
                                </div>
                            </div>
                        </div>
                        <div id="rightbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }}>
                        </div>

                    </div>
                </div>
            </div>

            <div
                id="bottom"
                style={{
                    position: "fixed",
                    width: "100%",
                    bottom: "0px",
                    height: "40px",
                    backgroundColor: "#101010",
                    zIndex: 10000,
                }}
            >
                <div
                    className="hidden-xs hidden-xxs"
                    style={{
                        display: "table",
                        width: "100%",
                        textAlign: "center",
                        color: "#8F8F8F",
                        fontSize: "11px",
                        lineHeight: "40px",
                    }}
                >
                    <div className='copyright_sec'>
                        Copyright (c) 2016 Macquarie Group Limited ABN 94 122 169 279. All rights
                        reserved.
                    </div>
                </div>
                <div
                    style={{
                        position: "absolute",
                        width: "46%",
                        height: "35px",
                        right: "10px",
                        bottom: "5px",
                    }}
                >
                    <table
                        className="hasnext"
                        style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                        <tbody>
                            <tr>
                                <td>
                                    <div className="nextlbl right">
                                        <div
                                            className="nextname "
                                            style={{ textAlign: "right", fontSize: "15px" }}
                                        >
                                            <Link to="/edu/why-trade-warrant/limited-loss">
                                                Limited loss
                                            </Link>
                                        </div>
                                    </div>
                                </td>
                                <td width="33px">
                                    <Link to="/edu/why-trade-warrant/limited-loss"><div className="next right" /></Link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div
                    style={{
                        position: "absolute",
                        width: "46%",
                        height: "35px",
                        left: "10px",
                        bottom: "5px",
                    }}
                >
                    <table
                        className="hasprev"
                        style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                        <tbody>
                            <tr>
                                <td width="33px">
                                    <Link to="/edu/why-trade-warrant"><div className="prev left" /></Link>
                                </td>
                                <td>
                                    <div className="prevlbl left">
                                        <div
                                            className="prevname "
                                            style={{ textAlign: "left", fontSize: "15px" }}
                                        >
                                            <Link to="/edu/why-trade-warrant">
                                                Why Trade Warrants?
                                            </Link>
                                        </div>

                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <SelectingWarrentImg Open={openLive} OpenModel={() => setOpenLive(!true)} Data={imageUrl} />
            </div>


            <div id="dotbar" className="hidden-sm hidden-xs" style={{}}>
                {/* <div className="dbtn dbtn-seminarbtn">
                    <Link
                        className="seminarbtn"
                        to="/education/seminar"
                    >
                        <img src='/img/education/button-static.png' alt="image" />
                    </Link>
                </div> */}
                <ChildInvestorAcademyCommon Location={location} Hist={history} />
            </div>

        </div>
    );
}
export default GearingEffects;